import * as React from 'react';
import { cn } from '../../lib/utils';
import { Heading, Text } from './typography';

/**
 * Standardized Card Component
 * Consistent styling across admin and user flows
 * Supports light and dark themes
 */
export const Card = React.forwardRef(function Card({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-gray-200 dark:border-gray-700',
        'bg-white dark:bg-gray-800',
        'shadow-sm',
        className
      )}
      {...props}
    />
  );
});

Card.displayName = 'Card';

export const CardHeader = React.forwardRef(function CardHeader({ className, ...props }, ref) {
  return <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />;
});

CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef(function CardTitle(
  { className, level = 3, ...props },
  ref
) {
  return (
    <Heading
      ref={ref}
      level={level}
      weight="semibold"
      className={cn('leading-none tracking-tight', className)}
      {...props}
    />
  );
});

CardTitle.displayName = 'CardTitle';

export const CardDescription = React.forwardRef(function CardDescription(
  { className, ...props },
  ref
) {
  return <Text ref={ref} size="sm" color="muted" className={className} {...props} />;
});

CardDescription.displayName = 'CardDescription';

export const CardContent = React.forwardRef(function CardContent({ className, ...props }, ref) {
  return <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />;
});

CardContent.displayName = 'CardContent';

export const CardFooter = React.forwardRef(function CardFooter({ className, ...props }, ref) {
  return <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />;
});

CardFooter.displayName = 'CardFooter';

export default { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
